import onDomReady from '../onDomReady';

export default class SortingDropdown {
	constructor() {
		this.initialize();
	}

	initialize() {
		onDomReady(() => {
			this.setupDropdowns();
			this.setupGlobalClick();
		});
	}

	setupDropdowns() {
		this.dropdownButtons = document.querySelectorAll(
			'.filter-dropdown-button',
		);
		this.dropdownContents = document.querySelectorAll(
			'.filter-dropdown-content',
		);

		this.dropdownButtons.forEach((button, index) => {
			button.addEventListener('click', event =>
				this.toggleDropdown(event, index),
			);
		});

		this.dropdownContents.forEach(content => {
			content.addEventListener('click', event => event.stopPropagation());
		});
	}

	setupGlobalClick() {
		document.body.addEventListener('click', () => this.closeAllDropdowns());
	}

	toggleDropdown(event, index) {
		const dropdownContent = this.dropdownContents[index];
		const isCurrentlyOpen = dropdownContent.classList.contains('open');

		this.closeAllDropdowns();

		if (!isCurrentlyOpen) {
			this.openDropdown(dropdownContent, event.currentTarget);
		}

		event.stopPropagation();
	}

	openDropdown(dropdownContent, button) {
		if (dropdownContent && button) {
			dropdownContent.classList.add('open');
			button.setAttribute('aria-expanded', 'true');
		}
	}

	closeAllDropdowns() {
		this.dropdownContents.forEach((content, index) => {
			if (content) {
				content.classList.remove('open');
			}
			const button = this.dropdownButtons[index];
			if (button) {
				button.setAttribute('aria-expanded', 'false');
			}
		});
	}
}
